import { Avatar, AvatarBadge, Box, Flex, Text, Tooltip } from '@chakra-ui/react'
import { ModalInfoRodizio } from './ModalInfoRodizio'
import { firstLetterUpperCaseAndRestLowerCase } from '../../../utils/capitalFirstLetter'
import { formatDate } from '../../../utils/formatDate'

export function Card({ item }) {
  return (
    <Box
      key={item.id}
      bg="white"
      borderRadius="md"
      p="4"
      mb="4"
      boxShadow="md"
      position="relative"
      w="100%"
    >
      <Box display="flex" alignItems="center" mb="4">
        <Box
          bg="gray.200"
          borderRadius="full"
          w="12"
          h="12"
          display="flex"
          alignItems="center"
          justifyContent="center"
          mr="4"
          position="relative"
        >
          <Avatar name={item.nome_parceiro}>
            <AvatarBadge boxSize="1.25em" bg="green.500" />
          </Avatar>
        </Box>
        <Flex flexDir="column" overflow="hidden" textOverflow="ellipsis">
          <Text color="gray.700" fontWeight="bold">
            {firstLetterUpperCaseAndRestLowerCase(item.nome_parceiro)}
          </Text>
          <Tooltip label={item.email_parceiro} placement="top">
            <Text color="gray.500" whiteSpace="nowrap" w="100%">
              Email: {item.email_parceiro}
            </Text>
          </Tooltip>
          <Text color="gray.500">Telefone: {item.telefone_parceiro}</Text>
          <Text color="gray.500">Contato origem: {item.origem_contato}</Text>
          <Text color="gray.500">Data da entrada do cliente: {item.data_entrada && formatDate(item.data_entrada)}</Text>
        </Flex>
      </Box>
      <Flex justifySelf="center" alignItems="center" justifyContent="center">
        <ModalInfoRodizio rodizio={item} />
      </Flex>
    </Box>
  )
}
